import { BaseEntity } from 'src/app/tools/models/baseEntity';


export class LeanTerm extends BaseEntity{
    
    termCode : string;
    name : string;

    
}